module.exports = __webpack_public_path__ + "static/media/aviso.cfec6a6f.jpg";